import { motion } from 'framer-motion'
import { Quote } from 'lucide-react'

const MotDuDG = () => {
  return (
    <div className="pt-32 pb-20 bg-gray-50 min-h-screen">
      <div className="container mx-auto px-4 md:px-6">
        <div className="max-w-6xl mx-auto">
          {/* Page Header */}
          <div className="text-center mb-16">
            <h1 className="text-4xl md:text-5xl font-bold text-cidh-blue mb-4 font-montserrat">Mot du DG</h1>
            <div className="w-24 h-1.5 bg-cidh-gold mx-auto mb-6"></div>
          </div>

          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center bg-white rounded-3xl overflow-hidden shadow-2xl border border-gray-100">
            {/* Image Section */}
            <div className="relative h-full min-h-[500px]">
              <img 
                src="/images/photo-pdg.jpeg" 
                alt="SAOURE Martin - DG" 
                className="absolute inset-0 w-full h-full object-cover"
              />
              <div className="absolute inset-0 bg-cidh-blue/10"></div>
              <div className="absolute bottom-0 left-0 right-0 p-8 bg-gradient-to-t from-cidh-blue/80 to-transparent text-white">
                <p className="text-2xl font-bold">SAOURE Martin</p>
                <p className="text-cidh-gold font-medium">Directeur Général</p>
              </div>
            </div>

            {/* Content Section */}
            <div className="p-8 md:p-12 lg:p-16 relative">
              <Quote className="text-cidh-gold/20 absolute top-8 right-8" size={120} />
              
              <div className="relative z-10">
                <div className="space-y-6 text-lg text-gray-700 leading-relaxed italic">
                  <p>
                    "L'homme en tant qu'être sociable a de tout temps besoin de son semblable pour vivre. 
                    Il est vrai que la vie sur terre devient de plus en plus difficile mais nous ne devons 
                    pas perdre de vue la nécessité de conjuguer nos efforts pour surmonter les vicissitudes de la vie."
                  </p>
                  <p>
                    "En créant CIDH Consulting SARL en octobre 2007, nous avions comme 
                    ambition d'accompagner les organisations dans la valorisation de leur 
                    capital humain et l'optimisation de leurs performances opérationnelles."
                  </p>
                </div>

                <div className="mt-10 pt-10 border-t border-gray-100">
                  <p className="text-2xl font-bold text-cidh-blue mb-1">Vive la solidarité agissante !</p>
                  
                  <div className="mt-8">
                    <p className="text-sm uppercase tracking-widest text-gray-400 font-semibold mb-1">Le DG</p>
                    <p className="text-xl font-bold text-cidh-blue">SAOURE Martin</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default MotDuDG
